import React from 'react';
import SignatureCanvas from 'react-signature-canvas';
import InputWrapper from '../InputWrapper';
import SignaturePad from '../SignaturePad';

interface SignatureInputControlledProps {
  name: string;
  sigCanvas: React.MutableRefObject<SignatureCanvas | null>;
  label?: string;
  disabled?: boolean;
  tooltip?: string;
  required?: boolean;
  alwaysShowClear?: boolean;
  onEnd?: () => void;
  onClear?: () => void;
}

function SignatureInputControlled({
  name,
  label,
  disabled,
  tooltip,
  required,
  alwaysShowClear,
  onEnd,
  sigCanvas,
  onClear,
}: SignatureInputControlledProps) {
  return (
    <InputWrapper
      label={label}
      name={name}
      tooltip={tooltip}
      required={required}>
      <SignaturePad
        sigCanvas={sigCanvas}
        disabled={disabled}
        alwaysShowClear={alwaysShowClear}
        onEnd={onEnd}
        onClear={onClear}
      />
    </InputWrapper>
  );
}

export default SignatureInputControlled;
